import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { useMotiveForm } from './hook';
import { MotiveData } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    MOTIVE,
    MOTIVE_DETAIL,
    MOTIVE_EDIT,
    MOTIVE_NEW,
} from '../../../../../routes/paths';
import { MotiveHistorical } from '../historical';

export const MotiveForm = () => {
    const {
        motive,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikMotiveData,
        motiveHistorical,
        showHistorical,
        setShowHistorical,
    } = useMotiveForm();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={motive && motive.id ? 'Editar motivo' : 'Crear motivo'}
                additionalButtons={
                    <ActionButtonGroup
                        id={encodeURIComponent(motive?.name || '')}
                        buttonCreate={{
                            show: Boolean(motive?.id),
                            route: MOTIVE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: MOTIVE,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: MOTIVE_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: MOTIVE_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(motive?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                        extraParam={motive?.active ?? ''}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <MotiveHistorical
                        historical={motiveHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <MotiveData
                data={motive}
                onChangeFormik={(formik) => setFormikMotiveData(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
